<template>
  <div id="clients_control">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/internal-control')" style="cursor: pointer">Control Interno
        </li>
        <li class="breadcrumb-item active">Verificaciones</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <!-- BUSCADOR -->
      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vx-card>
            <h3>Buscar cliente</h3>
            <vs-row vs-justify="center">
              <vs-col vs-justify="left" vs-align="left" vs-w="11">
                <vs-input size="large" color="warning" style="width: 100%"
                  label-placeholder="Criterios de búsqueda: UID, IID, CID, Email, RFC, CURP, Nombre, Razón social..."
                  v-model="search" v-on:keyup.enter="searchClient()" />
              </vs-col>
              <vs-col vs-justify="center" vs-align="center" vs-w="1">
                <vs-button size="large" style="margin-left: 35%; margin-top: 15%;" color="warning" type="filled"
                  icon="search" v-on:click="searchClient()" :disabled="buscando"></vs-button>
              </vs-col>
            </vs-row>
          </vx-card>
        </vs-col>
      </vs-row>

      <vs-row vs-justify="center" class="mb-4">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button color="warning" type="filled" icon="person_search" v-on:click="verificar = false"
            v-if="verificar == true">Ver resultado de Búsqueda</vs-button>
          <vs-button color="warning" type="filled" icon="how_to_reg" v-on:click="verificar = true" v-else>Ver Clientes Por
            Verificar</vs-button>
        </vs-col>
      </vs-row>

      <!-- CONTENIDO -->
      <div class="row">
        <div class="col-md-12">
          <vx-card>

            <!-- REFRESCAR -->
            <vs-row vs-justify="center">
              <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="1">
                <h5 v-if="verificar">Por Verificar</h5>
                <h5 v-else>Búsqueda</h5>
              </vs-col>
              <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="11">
                <vs-button color="warning" type="filled" icon="refresh" v-if="verificar"
                  @click="getCliensInVerification()"></vs-button>
              </vs-col>
            </vs-row>

            <!-- tabs -->
            <vs-tabs>
              <!-- VERIFICACIÓN DE IDENTIDAD -->
              <vs-tab :label="`Verificación de Identidad ${verificar ? '(' + active_data_identity.length + ')' : ''}`"
                icon="verified_user">
                <div class="row">
                  <div class="col-md-12">
                    <vs-table stripe search pagination max-items="50" :data="active_data_identity"
                      noDataText="No se encontraron registros">
                      <template slot="header">
                        <h3>Usuarios</h3>
                      </template>
                      <template slot="thead">
                        <vs-th v-for="(col, idx) in identityColumns" v-bind:key="'identity_' + idx"
                          :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr :key="index" v-for="(renglon, index) in data">
                          <vs-td>{{ renglon.uid }}</vs-td>
                          <vs-td>{{ renglon.bpid }}</vs-td>
                          <vs-td>{{ renglon.ppid }}</vs-td>
                          <vs-td>{{ renglon.ciid }}</vs-td>
                          <vs-td>{{ renglon.type }}</vs-td>
                          <vs-td>{{ renglon.name }}</vs-td>
                          <vs-td v-if="renglon.rfc_tin === 1">{{ renglon.rfc }}</vs-td>
                          <vs-td v-else>{{ renglon.tin }}</vs-td>
                          <vs-td>{{ renglon.curp }}</vs-td>
                          <vs-td>{{ renglon.email }}</vs-td>
                          <vs-td>{{ renglon.alias }}</vs-td>
                          <vs-td>
                            <vs-button color="primary" type="flat" v-on:click="showModal('identidad', renglon)">
                              {{ getStatus(renglon.videntidad) }}
                            </vs-button>
                          </vs-td>
                          <vs-td>
                            <div class="row">
                              <div class="col-md-6">
                                <vs-button radius color="danger" type="filled" icon="dashboard"
                                  v-on:click="verPanel(renglon)"></vs-button>
                              </div>
                              <div class="col-md-6">
                                <vs-button radius color="warning" type="filled" icon="folder_shared"
                                  v-on:click="verExpediente(renglon)"></vs-button>
                              </div>
                            </div>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </vs-tab>

              <!-- VERIFICACIÓN DE BANCO -->
              <vs-tab
                :label="`Verificación de Banco ${verificar ? '(' + active_data_bank.filter(item => item.sid === null).length + ')' : ''}`"
                icon="account_balance">
                <div class="row">
                  <div class="col-md-12">
                    <vs-table stripe search pagination max-items="50" :data="active_data_bank"
                      noDataText="No se encontraron registros">
                      <template slot="header">
                        <h3>Usuarios</h3>
                      </template>
                      <template slot="thead" v-for="(col, idx) in bankColumns">
                        <vs-th v-bind:key="'bank' + idx" :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr v-show="renglon.sid === null" :key="index" v-for="(renglon, index) in data">
                          <vs-td>{{ renglon.uid }}</vs-td>
                          <vs-td>{{ renglon.bpid }}</vs-td>
                          <vs-td>{{ renglon.ppid }}</vs-td>
                          <vs-td>{{ renglon.ciid }}</vs-td>
                          <vs-td>{{ renglon.type }}</vs-td>
                          <vs-td>{{ renglon.name }}</vs-td>
                          <vs-td v-if="renglon.rfc_tin === 1">{{ renglon.rfc }}</vs-td>
                          <vs-td v-else>{{ renglon.tin }}</vs-td>
                          <vs-td>{{ renglon.curp }}</vs-td>
                          <vs-td>{{ renglon.email }}</vs-td>
                          <vs-td>{{ renglon.alias }}</vs-td>
                          <vs-td v-if="renglon.vbanco != null">
                            <vs-button color="primary" type="flat" v-on:click="showModal('banco', renglon)">
                              {{ getVBanco(renglon.vbanco) }}
                            </vs-button>
                          </vs-td>
                          <vs-td v-else>{{ getVBanco(renglon.vbanco) }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </vs-tab>

              <!-- VERIFICACIÓN DE STP -->
              <vs-tab :label="`Verificación STP ${verificar ? '(' + active_data_stp.length + ')' : ''}`"
                icon="account_balance_wallet">
                <div class="row">
                  <div class="col-md-12">
                    <vs-table stripe search pagination max-items="50" :data="active_data_stp"
                      noDataText="No se encontraron registros">
                      <template slot="header">
                        <h3>Usuarios</h3>
                      </template>
                      <template slot="thead" v-for="(col, idx) in STPColumns">
                        <vs-th v-bind:key="'bank' + idx" :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr :key="index" v-for="(renglon, index) in data">
                          <vs-td>{{ renglon.uid }}</vs-td>
                          <vs-td>{{ renglon.bpid }}</vs-td>
                          <vs-td>{{ renglon.ppid }}</vs-td>
                          <vs-td>{{ renglon.ciid }}</vs-td>
                          <vs-td>{{ renglon.type }}</vs-td>
                          <vs-td>{{ renglon.name }}</vs-td>
                          <vs-td v-if="renglon.rfc_tin === 1">{{ renglon.rfc }}</vs-td>
                          <vs-td v-else>{{ renglon.tin }}</vs-td>
                          <vs-td>{{ renglon.curp }}</vs-td>
                          <vs-td>{{ renglon.email }}</vs-td>
                          <vs-td>{{ renglon.alias }}</vs-td>
                          <vs-td v-if="renglon.istp !== 'N/A'">
                            <vs-button color="primary" type="flat" v-on:click="verSTP(renglon, 'Inversionista')">
                              {{ renglon.istp }}
                            </vs-button>
                          </vs-td>
                          <vs-td v-else>{{ renglon.istp }}</vs-td>
                          <vs-td v-if="renglon.astp !== 'N/A'">
                            <vs-button color="primary" type="flat" v-on:click="verSTP(renglon, 'Solicitante')">
                              {{ renglon.astp }}
                            </vs-button>
                          </vs-td>
                          <vs-td v-else>{{ renglon.sstp }}</vs-td>
                          <vs-td v-if="renglon.sstp !== 'N/A'">
                            <vs-button color="primary" type="flat" v-on:click="verSTP(renglon, 'Proveedor')">
                              {{ renglon.sstp }}
                            </vs-button>
                          </vs-td>
                          <vs-td v-else>{{ renglon.sstp }}</vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </div>
              </vs-tab>

            </vs-tabs>
          </vx-card>
        </div>
      </div>
    </div>

    <!--MODAL V. IDENTIDAD-->
    <vs-popup :title="titleIdentidad" :active.sync="showIdentidad" class="con-vs-popup extended-popup">
      <vs-row v-if="elemento != null" vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <vs-table noDataText="">
              <template slot="thead">
                <vs-th style="text-align: left !important">IVID</vs-th>
                <vs-th style="text-align: left !important">UID</vs-th>
                <vs-th style="text-align: left !important">IID</vs-th>
                <vs-th style="text-align: left !important">CID</vs-th>
                <vs-th style="text-align: left !important">Nombre</vs-th>
                <vs-th style="text-align: left !important">Status</vs-th>
                <vs-th style="text-align: left !important">F. Creación</vs-th>
                <vs-th style="text-align: left !important">Dashboard</vs-th>
              </template>
              <vs-tr>
                <vs-td>{{ elemento.ivid }}</vs-td>
                <vs-td>{{ elemento.uid }}</vs-td>
                <vs-td>{{ elemento.iid }}</vs-td>
                <vs-td>{{ elemento.cid }}</vs-td>
                <vs-td>{{ elemento.name }}</vs-td>
                <vs-td>{{ getStatus(elemento.videntidad) }}</vs-td>
                <vs-td>{{ elemento.ivcreacion | human_date }}</vs-td>
                <vs-td>
                  <vs-button :disabled="!elemento.ivresource" radius color="dark" class="ml-2" icon-pack="feather"
                    icon="icon-eye" target :href="$sanitizeUrl(elemento.ivresource)"></vs-button>
                </vs-td>
              </vs-tr>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-divider color="warning" />
      <!--CORRECCIÓN DE DATOS-->
      <vs-row v-if="elemento != null" vs-justify="center">
        <vs-col v-if="elemento.videntidad == 6" type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card class="cardx" fixedHeight>
            <div slot="header">
              <h5>Corrección de Datos</h5>
            </div>
            <div style="margin-bottom: 1%">
              <vs-table noDataText="">
                <template slot="thead">
                  <vs-th>Primer Nombre</vs-th>
                  <vs-th>Segundo Nombre</vs-th>
                  <vs-th>Apellido Paterno</vs-th>
                  <vs-th>Apellido Materno</vs-th>
                </template>
                <vs-tr>
                  <vs-td><vs-input class="inputx" placeholder="Primer nombre" v-model="elemento.first_name" /></vs-td>
                  <vs-td><vs-input class="inputx" placeholder="Segundo nombre" v-model="elemento.second_name" /></vs-td>
                  <vs-td><vs-input class="inputx" placeholder="Apellido Paterno"
                      v-model="elemento.last_name_1" /></vs-td>
                  <vs-td><vs-input class="inputx" placeholder="Apellido Materno"
                      v-model="elemento.last_name_2" /></vs-td>
                </vs-tr>
              </vs-table>
              <vs-table noDataText="">
                <template slot="thead">
                  <vs-th>F. Nacimiento</vs-th>
                  <vs-th>CURP</vs-th>
                  <vs-th>Género</vs-th>
                  <vs-th>Nacionalidad</vs-th>
                </template>
                <vs-tr>
                  <vs-td><input type="date" class="form-control" v-model="elemento.birth_date"></vs-td>
                  <vs-td><vs-input class="inputx" placeholder="CURP" v-model="elemento.curp" /></vs-td>
                  <vs-td>
                    <vs-select v-model="elemento.gender">
                      <vs-select-item value="1" text="Masculino" />
                      <vs-select-item value="2" text="Femenino" />
                    </vs-select>
                  </vs-td>
                  <vs-td>
                    <vs-select v-model="elemento.citizenship">
                      <vs-select-item v-for="(c, cIndex) in collections.countries" :key="cIndex" :value="c.value"
                        :text="c.text" />
                    </vs-select>
                  </vs-td>
                </vs-tr>
              </vs-table>
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                <vs-button color="warning" type="filled" icon="save" style="float: right"
                  v-on:click="changePersonalData()">Guardar</vs-button>
              </vs-row>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <div v-if="elemento != null">
        <vs-divider color="warning" v-if="elemento.videntidad == 6" />
      </div>
      <!--BITÁCORA-->
      <vs-row v-if="elemento != null" vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <div slot="header">
              <h5>Notificación para cliente</h5>
            </div>
            <vs-textarea label="Escribe los comentarios..." v-model="reasons" />
            <vs-button color="warning" type="filled" icon="send" style="float: right; margin-bottom: 20px"
              v-on:click="from = 'identidad'; enviarCorreo();">Enviar Correo</vs-button>
            <vs-divider color="warning" style="margin-top: 10px" />
            <vs-table noDataText="">
              <vs-tr v-for="message in messages" v-bind:key="message.id">
                <vs-td style="width: 10%;">
                  <vs-chip color="primary" style="width: 100%;">
                    <vs-icon icon="schedule" color="white" style="margin-right: 10%; margin-left: -10%" />
                    {{ message.created_at | human_date }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <vs-chip color="orange">
                    <vs-icon icon="person" color="white" />
                    {{ message.email }}
                  </vs-chip><br><br>
                  <div class="note-pad">{{ message.note }}</div>
                </vs-td>
              </vs-tr>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-popup>

    <!--MODAL V. BANCO-->
    <vs-popup :title="titleBanco" :active.sync="showBanco" class="con-vs-popup extended-popup">
      <vs-row v-if="elemento != null" vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <template lang="html">
              <div>
                <vs-table noDataText="" v-if="elemento.person_type === 1 || elemento.person_type === 2">
                  <template slot="thead">
                    <vs-th>Nombre</vs-th>
                    <vs-th v-if="elemento.person_type === 1">CURP</vs-th>
                    <vs-th v-if="elemento.rfc_tin === 1">RFC</vs-th>
                    <vs-th v-else>TIN</vs-th>
                  </template>
                  <template>
                    <vs-tr>
                      <vs-td>{{ fullName }}</vs-td>
                      <vs-td v-if="elemento.person_type === 1">{{ elemento.curp }}</vs-td>
                      <vs-td v-if="elemento.rfc_tin === 1">{{ elemento.rfc }}</vs-td>
                      <vs-td v-else>{{ elemento.tin }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </template>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row v-if="elemento != null" vs-justify="center" style="margin-top:20px;">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card>
            <h5>
              Identificación Frente
              <a :href="StorageURL + id_front.url_file" target="_blank" download><em
                  class="material-icons">file_download</em></a>
              <a :href="StorageURL + id_front.url_file" target="_blank"><em class="material-icons">open_in_new</em></a>
            </h5>
            <embed :src="StorageURL + id_front.url_file" width="600" height="300" alt="pdf"
              pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" v-if="isPDF(id_front.filename)">
            <div class="file" v-else>
              <img :src="StorageURL + id_front.url_file" style="max-width:600px;">
            </div>
          </vs-card>
        </vs-col>
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-card>
            <h5>
              Identificación posterior
              <a :href="StorageURL + id_back.url_file" target="_blank" download><em
                  class="material-icons">file_download</em></a>
              <a :href="StorageURL + id_back.url_file" target="_blank"><em class="material-icons">open_in_new</em></a>
            </h5>
            <embed :src="StorageURL + id_back.url_file" width="600" height="300" alt="pdf"
              pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" v-if="isPDF(id_back.filename)">
            <div class="file" v-else>
              <img :src="StorageURL + id_back.url_file" style="max-width:600px;">
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row vs-row v-if="elemento != null && user_data != null" vs-justify="center" style="margin-top:20px;">
        <vs-col vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12"
          v-if="user_data.filter(item => { return item.verified === BankAccountStatus.VERIFIED_REQUESTED }).length > 0">
          <vs-card>
            <div slot="header">
              <h5>Cuentas de Banco a Verificar</h5>
            </div>
            <template lang="html">
              <div>
                <vs-table stripe
                  :data="user_data.filter(item => { return item.verified === BankAccountStatus.VERIFIED_REQUESTED })"
                  noDataText="">
                  <template slot="thead">
                    <vs-th>Banco</vs-th>
                    <vs-th>CLABE</vs-th>
                    <vs-th>Cuenta</vs-th>
                    <vs-th>BIC/SWIFT</vs-th>
                    <vs-th>IBAN</vs-th>
                    <vs-th>Routing Number</vs-th>
                    <vs-th>Dirección</vs-th>
                    <vs-th>Estado de Cuenta</vs-th>
                    <vs-th>Verificar</vs-th>
                  </template>
                  <template
                    v-for="(cuenta, index) in user_data.filter(item => { return item.verified === BankAccountStatus.VERIFIED_REQUESTED })">
                    <vs-tr>
                      <vs-td>{{ cuenta.bank.short_name }}</vs-td>
                      <vs-td>{{ cuenta.clabe }}</vs-td>
                      <vs-td>{{ cuenta.account }}</vs-td>
                      <vs-td>{{ cuenta.bic_swift }}</vs-td>
                      <vs-td>{{ cuenta.iban }}</vs-td>
                      <vs-td>{{ cuenta.routing_number }}</vs-td>
                      <vs-td>{{ cuenta.bank_address }}</vs-td>
                      <vs-td>
                        <vs-button color="warning" type="filled" icon="visibility_off" @click="verEDC(index)"
                          v-if="showedEDC.includes(index)">Ocultar</vs-button>
                        <vs-button color="warning" type="filled" icon="visibility" @click="verEDC(index)"
                          v-else>Ver</vs-button>
                      </vs-td>
                      <vs-td v-if="loadingBankVerification"><vs-button color="success" type="filled"
                          :disabled="true">Verificando...</vs-button></vs-td>
                      <vs-td v-else><vs-button color="success" type="filled" icon="done"
                          @click="verify(cuenta)">Verificar</vs-button></vs-td>
                    </vs-tr>
                    <div v-if="showedEDC.includes(index)">
                      <document-upload-lite name="Caratula Estado de Cuenta" :check-url="checkUrl(cuenta)"
                        :view-url="viewUrl(cuenta)" :download-url="downloadUrl(cuenta)" upload-url="/" width="1"
                        style="margin-left: 200%" :canUpload="false" />
                    </div>
                  </template>
                </vs-table>
              </div>
            </template>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row vs-row v-if="elemento != null && user_data != null" vs-justify="center" style="margin-top:20px;">
        <vs-col vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12"
          v-if="user_data.filter(item => { return item.verified !== BankAccountStatus.VERIFIED_REQUESTED }).length > 0">
          <vs-card>
            <div slot="header">
              <h5>Otras Cuentas de Banco</h5>
            </div>
            <template lang="html">
              <div>
                <vs-table
                  :data="user_data.filter(item => { return item.verified !== BankAccountStatus.VERIFIED_REQUESTED })"
                  noDataText="">
                  <template slot="thead">
                    <vs-th>BID</vs-th>
                    <vs-th colspan="3">CLABE/BIC/SWIFT</vs-th>
                    <vs-th>Favorita</vs-th>
                    <vs-th>Estatus</vs-th>
                    <vs-th>F. Verificación</vs-th>
                    <vs-th>Acciones</vs-th>
                  </template>
                  <template
                    v-for="(cuenta, index) in user_data.filter(item => { return item.verified !== BankAccountStatus.VERIFIED_REQUESTED })">
                    <vs-tr>
                      <vs-td>{{ cuenta.pivot.bank_account_id }}</vs-td>
                      <vs-td v-if="cuenta.clabe !== null" colspan="3">{{ cuenta.clabe }}</vs-td>
                      <vs-td v-else>{{ cuenta.bic_swift }}</vs-td>
                      <vs-td>
                        <vs-icon icon="star" size="medium" color="warning" v-if="cuenta.is_default === 1" />
                      </vs-td>
                      <vs-td>{{ getVBanco(cuenta.verified) }}</vs-td>
                      <vs-td>{{ cuenta.verified_date | human_date }}</vs-td>
                      <vs-td>
                        <vs-button color="warning" type="filled" icon="visibility_off" @click="verCuenta(index)"
                          v-if="showedCuentas.includes(index)">Ocultar</vs-button>
                        <vs-button color="warning" type="filled" icon="visibility" @click="verCuenta(index)"
                          v-else>Ver</vs-button>
                      </vs-td>
                    </vs-tr>
                    <vs-tr v-if="showedCuentas.includes(index)">
                      <vs-th>Banco</vs-th>
                      <vs-th>CLABE</vs-th>
                      <vs-th>Cuenta</vs-th>
                      <vs-th>BIC/SWIFT</vs-th>
                      <vs-th>IBAN</vs-th>
                      <vs-th>Routing Number</vs-th>
                      <vs-th>Dirección</vs-th>
                      <vs-th>Verificado Por</vs-th>
                    </vs-tr>
                    <vs-tr v-if="showedCuentas.includes(index)">
                      <vs-td>{{ cuenta.bank.short_name }}</vs-td>
                      <vs-td>{{ cuenta.clabe }}</vs-td>
                      <vs-td>{{ cuenta.account }}</vs-td>
                      <vs-td>{{ cuenta.bic_swift }}</vs-td>
                      <vs-td>{{ cuenta.iban }}</vs-td>
                      <vs-td>{{ cuenta.routing_number }}</vs-td>
                      <vs-td>{{ cuenta.bank_address }}</vs-td>
                      <vs-td>{{ cuenta.verified_by }}</vs-td>
                    </vs-tr>
                    <div v-if="showedCuentas.includes(index)" style="margin-top: 5%">
                      <document-upload-lite name="Caratula Estado de Cuenta" :check-url="checkUrl(cuenta)"
                        :view-url="viewUrl(cuenta)" :download-url="downloadUrl(cuenta)" upload-url="/" width="1"
                        style="margin-left: 180%" :canUpload="false" />
                    </div>
                  </template>
                </vs-table>
              </div>
            </template>
          </vs-card>
        </vs-col>
      </vs-row>
      <!--CRITERIOS DE VERIFICACION-->
      <vs-row v-if="elemento != null" vs-justify="center" style="margin-top:10px;">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <div>
              <vs-list>
                <vs-list-header icon="how_to_reg" title="Criterios de verificación" color="success" />
                <vs-list-item icon="check" title="El estado de cuenta no debe ser mayor a 6 meses." />
                <vs-list-item icon="check"
                  title="El nombre de la identificación debe  corresponder con el estado de cuenta." />
                <vs-list-item icon="check" title="La CLABE del estado de cuenta debe corresponder con el registrado." />
              </vs-list>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row v-if="elemento != null" vs-justify="center" style="margin-top:10px;">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <div slot="header">
              <h5>Notificación a cliente</h5>
            </div>
            <vs-textarea label="Escribe los comentarios..." v-model="reasons" />
            <vs-button color="warning" type="filled" icon="send" style="float: right; margin-bottom: 20px"
              v-on:click="from = 'banco'; requestEmail();">Enviar Correo</vs-button>
            <vs-divider color="warning" style="margin-top: 10px" />
            <vs-table noDataText="">
              <vs-tr v-for="message in messages" v-bind:key="message.id">
                <vs-td style="width: 10%;">
                  <vs-chip color="primary" style="width: 100%;">
                    <vs-icon icon="schedule" color="white" style="margin-right: 10%; margin-left: -10%" />
                    {{ message.created_at | human_date }}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <vs-chip color="orange">
                    <vs-icon icon="person" color="white" />
                    {{ message.email }}
                  </vs-chip><br><br>
                  <div class="note-pad">{{ message.note }}</div>
                </vs-td>
              </vs-tr>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>

      <vs-popup title="Enviar correo" :active.sync="popupActivo3">
        <p>
          {{ emailBody }}
          <br><br>
          <strong>{{ reasons }}</strong>
        </p>
        <br><br>
        <vs-button @click="enviarCorreo()" color="primary" type="filled">Envíar notificación</vs-button>
      </vs-popup>
    </vs-popup>

    <!--MODAL STP-->
    <vs-popup :title="titleSTP" :active.sync="showSTP" class="con-vs-popup extended-popup">
      <vs-row v-if="elemento != null" vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vx-card v-if="type === 'Solicitante'" class="mb-2">
            <small>Projectos del solicitante: </small>
            <a :key="prindex" v-for="(pr, prindex) in user_stp_pr" style="cursor:pointer;" class="bold"
              @click="handleSelected(pr)">{{ pr }}, </a>
          </vx-card>
          <template lang="html">
            <div>
              <vs-table stripe :data="user_stp_ac" noDataText="No se encontraron cuentas">
                <template slot="thead">
                  <vs-th>ID</vs-th>
                  <vs-th>Estatus</vs-th>
                  <vs-th>Detalle Error</vs-th>
                  <vs-th>CLABE</vs-th>
                  <vs-th>F. Creación</vs-th>
                  <vs-th>F. Asignación</vs-th>
                  <vs-th>Log</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index" v-for="(ac, index) in data">
                    <vs-td>{{ ac.id }}</vs-td>
                    <vs-td>{{ ac.status }}</vs-td>
                    <vs-td>{{ ac.error_details }}</vs-td>
                    <vs-td>{{ ac.stp_clabe }}</vs-td>
                    <vs-td>{{ ac.created_at }}</vs-td>
                    <vs-td>{{ ac.assignment_date }}</vs-td>
                    <vs-td>{{ ac.stp_record }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </template>
          <div v-if="type === 'Inversionista'">
            <vs-button style="float: right" color="warning" type="filled"
              v-if="elemento.istp == 'No creada' || elemento.istp.includes('error')"
              v-on:click="crearCuentaSTP(type)">Crear
              Cuenta</vs-button>
          </div>
          <div v-else-if="type === 'Solicitante'">
            <vs-button style="float: right" color="warning" type="filled"
              v-if="elemento.astp == 'No creada' || elemento.astp.includes('error')"
              v-on:click="crearCuentaSTP(type)">Crear
              Cuenta</vs-button>
          </div>
          <div v-else>
            <vs-button style="float: right" color="warning" type="filled"
              v-if="elemento.sstp == 'No creada' || elemento.astp.includes('error')"
              v-on:click="crearCuentaSTP(type)">Crear
              Cuenta</vs-button>
          </div>
        </vs-col>
      </vs-row>
    </vs-popup>

    <!--MODAL PANEL-->
    <vs-popup :title="titleCumplimiento" :active.sync="showCumplimiento" class="con-vs-popup extended-popup">
      <vs-row v-if="elemento != null" vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <template lang="html">
            <div>
              <vs-table stripe :data="user_crs" noDataText="">
                <template slot="thead">
                  <vs-th>Requerimiento</vs-th>
                  <!-- <vs-th style="text-align: center">¿Es requerido?</vs-th> -->
                  <vs-th>¿Completado?</vs-th>
                  <!-- <vs-th>Fecha de Req. de Cumplimiento</vs-th> -->
                  <!-- <vs-th style="text-align: center">Fecha de Cumplimiento</vs-th> -->
                  <!-- <vs-th style="text-align: center">Evidencia de Cumplimiento</vs-th> -->
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="index" v-for="(ucr, index) in data">
                    <vs-td>{{ ucr.requirement }}</vs-td>
                    <!-- <vs-td style="text-align: center">
                      <vs-icon icon="check_circle" size="medium" color="green" v-if="ucr.is_required"/>
                      <vs-icon icon="panorama_fish_eye" size="medium" color="dark" v-else/>
                    </vs-td> -->
                    <vs-td>
                      <vs-icon v-if="ucr.is_complied" icon="check_circle" size="small" color="green" />
                      <vs-icon v-else icon="dangerous" size="small" color="red" />
                    </vs-td>
                    <!-- <vs-td>{{ucr.compliance_requirement_date | human_date}}</vs-td> -->
                    <!-- <vs-td style="text-align: center">{{ucr.compliance_date | human_date}}</vs-td> -->
                    <!-- <vs-td style="text-align: center">{{ucr.compliance_evidence}}</vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </template>
        </vs-col>
      </vs-row>
    </vs-popup>

    <!--MODAL EXPEDIENTE-->
    <vs-popup :title="titleExpediente" :active.sync="showExpediente" class="con-vs-popup mid-popup">
      <vs-row v-if="elemento != null" vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <expediente :loading="loading" :tipousuario="tipousuario" :tipopersona="tipopersona" :pp="pp"
            :transacciones="transacciones" :userid="userid" :email="email" :acceso="acceso" :login="login" :mfa="mfa">
          </expediente>
        </vs-col>
      </vs-row>
    </vs-popup>

  </div>
</template>

<script lang="js">
import * as moment from 'moment'
import { mapState } from "vuex";
import DocumentUploadLite from "@components/misc/DocumentUploadLite";
import { BankAccountStatus } from "@/models/BankAccountStatus";

const emailBody = "Tuvimos problemas para verificar tu cuenta de banco, por favor atiende los siguientes comentarios.";
const identityColumns = [
  { title: "UID", key: "user_id", sortable: true }
  , { title: "BPID", key: "business_profile_id", sortable: true }
  , { title: "PPID", key: "personal_profile_id", sortable: true }
  , { title: "IID/CID/SID", key: "rol_id", sortable: true }
  , { title: "TIPO", key: "person_type", sortable: false }
  , { title: "NOMBRE/RAZON SOCIAL", key: "name", sortable: true }
  , { title: "RFC/TAX ID", key: "rfc_tax_id", sortable: true }
  , { title: "CURP", key: "curp", sortable: true }
  , { title: "EMAIL", key: "email", sortable: true }
  , { title: "ALIAS", key: "alias", sortable: true }
  , { title: "VERIFICACIÓN", key: "v_actions", sortable: false }
  , { title: "ACCIONES", key: "actions", sortable: false }
];
const bankColumns = [
  { title: "UID", key: "user_id", sortable: true }
  , { title: "BPID", key: "business_profile_id", sortable: true }
  , { title: "PPID", key: "personal_profile_id", sortable: true }
  , { title: "IID/CID", key: "rol_id", sortable: true }
  , { title: "TIPO", key: "person_type", sortable: false }
  , { title: "NOMBRE/RAZON SOCIAL", key: "name", sortable: true }
  , { title: "RFC/TAX ID", key: "rfc_tax_id", sortable: true }
  , { title: "CURP", key: "curp", sortable: true }
  , { title: "EMAIL", key: "email", sortable: true }
  , { title: "ALIAS", key: "alias", sortable: true }
  , { title: "VERIFICACIÓN", key: "v_actions", sortable: false }
];
const STPColumns = [
  { title: "UID", key: "user_id", sortable: true }
  , { title: "BPID", key: "business_profile_id", sortable: true }
  , { title: "PPID", key: "personal_profile_id", sortable: true }
  , { title: "IID/CID/SID", key: "rol_id", sortable: true }
  , { title: "TIPO", key: "person_type", sortable: false }
  , { title: "NOMBRE/RAZON SOCIAL", key: "name", sortable: true }
  , { title: "RFC/TAX ID", key: "rfc_tax_id", sortable: true }
  , { title: "CURP", key: "curp", sortable: true }
  , { title: "EMAIL", key: "email", sortable: true }
  , { title: "ALIAS", key: "alias", sortable: true }
  , { title: "CLABE STP INVERSIONISTA", key: "stp_investor", sortable: false }
  , { title: "CLABE STP SOLICITANTE", key: "stp_applicant", sortable: false }
  , { title: "CLABE STP PROVEEDOR", key: "stp_supplier", sortable: false }
];

let Expediente = require('./Expediente').default;
export default {
  name: 'clients-control',
  props: [],
  filters: {
    human_date(date) {
      return date == null ? '' : moment(date).lang("es").format("D MMM YY");
    }
  },
  components: {
    'expediente': Expediente,
    DocumentUploadLite
  },
  async mounted() {
    await this.getCollections();
    await this.getCliensInVerification("identity");
    await this.getCliensInVerification("bank");
    await this.getCliensInVerification("stp");
  },
  data() {
    return {
      active_data: [],
      data: [],
      clientsInVerification: [],
      search: '',
      verificar: true,
      elemento: null,
      reasons: '',
      messages: [],
      user_data: null,
      from: '',
      buscando: false,
      id_front: '',
      id_back: '',
      accountfile: '',

      loading: false,
      pp: null,
      tipousuario: null,
      tipopersona: null,
      userid: null,
      email: null,
      transacciones: null,
      acceso: null,
      login: null,
      mfa: null,

      showIdentidad: false,
      titleIdentidad: '',
      showBanco: false,
      titleBanco: '',
      loadingBankVerification: false,
      showSTP: false,
      titleSTP: '',
      showCumplimiento: false,
      titleCumplimiento: '',
      showExpediente: false,
      titleExpediente: '',

      user_crs: [],
      user_stp_ac: [],
      user_stp_pr: [],
      type: null,
      liga: '',

      showedEDC: [],
      showedCuentas: [],
      popupActivo3: false,
      emailBody: emailBody,
      identityColumns: identityColumns,
      bankColumns: bankColumns,
      STPColumns: STPColumns,
      collections: {
        countries: [],
      },
      identityVerificationData: [],
      bankVerificationData: [],
      stpAccountsVerificationData: [],
      active_data_identity: [],
      active_data_bank: [],
      active_data_stp: [],
    }
  },
  methods: {
    getCliensInVerification(type = "identity") {
      this.$vs.notify({ title: 'Cargando...', text: 'Espere un momento', color: 'dark', position: 'bottom-center', icon: 'access_time' })
      axios.get(`/api/clients-control/${type}`).then((resolve) => {
        this.$vs.notify({ title: '¡Listo!', text: 'Datos cargados correctamente', color: 'success', position: 'bottom-center', icon: 'done' })
        switch (type) {
          case "identity":
            this.identityVerificationData = resolve.data.data;
            this.active_data_identity = resolve.data.data;
            break;
          case "bank":
            this.bankVerificationData = resolve.data.data;
            this.active_data_bank = resolve.data.data;
            break;
          case "stp":
            this.stpAccountsVerificationData = resolve.data.data;
            this.active_data_stp = resolve.data.data;
            break;
          default:
            this.clientsInVerification = resolve.data.data;
            this.active_data = resolve.data.data;
        }
      }).catch(error => {
        console.log(error);
        this.$vs.notify({ title: '¡ERROR!', text: 'Algo salió mal...', color: 'danger', position: 'bottom-center', icon: 'error' })
      });
    },
    isPDF(filename) {
      if (filename != null) {
        var datas = filename.split('.')
        var data = datas[datas.length - 1]
        if (data.toLowerCase() == 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    buscar(renglon) {
      this.user_data = null;
      axios.get('api/backoffice/bank-account/' + renglon.uid).then(response => {
        this.user_data = response.data
        this.getClientDocuments();
      })
    },
    verify(cuenta) {
      this.$vs.notify({ title: 'Enviando...', text: 'Espere un momento', color: 'dark', position: 'bottom-center', icon: 'access_time' })
      this.loadingBankVerification = true;
      axios.get('/api/users/' + this.elemento.uid + '/verify/' + cuenta.pivot.bank_account_id).then(response => {
        this.$vs.notify({ title: '¡Listo!', text: 'Verificación realizada correctamente', color: 'success', position: 'bottom-center', icon: 'done' })
        this.getCliensInVerification("identity");
        this.getCliensInVerification("bank");
        this.getCliensInVerification("stp");
        this.user_data = null;
        this.loadingBankVerification = false;
        this.buscar(this.elemento);
      }).catch(error => {
        this.$vs.notify({ title: '¡ERROR!', text: 'Algo salió mal...', color: 'danger', position: 'bottom-center', icon: 'error' })
      })
    },
    getStatus(status) {
      switch (status) {
        case 1: return 'Verificado'; break;
        case 2: return 'Revisión necesaria'; break;
        case 3: return 'Verificando'; break;
        case 4: return 'Rechazado'; break;
        case 5: return 'Se requiere nuevo intento'; break;
        case 6: return 'Datos no coinciden'; break;
        default: return 'No definido'; break;
      }
    },
    getVBanco(banco) {
      switch (banco) {
        case BankAccountStatus.UNVERIFIED: return 'No verificada'; break;
        case BankAccountStatus.VERIFIED: return 'Verificada'; break;
        case BankAccountStatus.VERIFIED_REQUESTED: return 'En verificación'; break;
        case BankAccountStatus.REJECTED: return 'Verificación rechazada'; break;
        default: return 'No encontrada'; break;
      }
    },
    requestEmail() {
      this.popupActivo3 = true;
    },
    enviarCorreo() {
      this.$vs.notify({ title: 'Enviando correo...', text: 'Espere un momento', color: 'dark', position: 'bottom-center', icon: 'access_time' })
      axios.post('/api/clients-control/send/correo', {
        reasons: this.reasons,
        nombre: this.elemento.name,
        email: this.elemento.email,
        ivid: this.elemento.ivid,
        iid: this.elemento.iid,
        cid: this.elemento.cid,
        from: this.from
      }).then((resolve) => {
        this.$vs.notify({ title: '¡Listo!', text: 'Correo enviado correctamente', color: 'success', position: 'bottom-center', icon: 'done' })
        this.reasons = ''
        this.popupActivo3 = false;
        this.elemento = null
        this.user_data = null
        this.messages = [];
      }).catch(error => {
        this.$vs.notify({ title: '¡ERROR!', text: 'Algo salió mal...', color: 'danger', position: 'bottom-center', icon: 'error' })
      });
    },
    showModal(destino, renglon) {
      this.elemento = renglon;
      if (destino === "identidad") {
        this.showIdentidad = true;
        this.titleIdentidad = this.elemento.name + " | V. Identidad";
      }
      if (destino === "banco") {
        this.buscar(renglon);
        this.showBanco = true;
        this.titleBanco = this.elemento.name + ' | V. Banco';
      }
      if (destino === "stp") {
        this.showSTP = true
        this.titleSTP = this.type + ': ' + this.elemento.name + ' | V. CLABE STP';
      }
      if (destino === "panel") {
        this.showCumplimiento = true;
        this.titleCumplimiento = this.elemento.name + ' | V. Cumplimiento';
      }
      if (destino === "expediente") {
        this.showExpediente = true;
        this.titleExpediente = this.elemento.name + ' | Expediente';
      }
    },
    hideModal(destino) {
      this.elemento = null;
      this.user_data = null;
      this.messages = [];
      if (destino === "identidad") {
        this.showIdentidad = false;
        this.titleIdentidad = '';
      }
      if (destino === "banco") {
        this.showBanco = false;
        this.titleBanco = '';
      }
      if (destino === "stp") {
        this.showSTP = false
        this.titleSTP = '';
      }
      if (destino === "panel") {
        this.showCumplimiento = false;
        this.titleCumplimiento = '';
      }
      if (destino === "expediente") {
        this.showExpediente = false;
        this.titleExpediente = '';
      }
    },
    searchClient() {
      if (this.search !== '') {
        if (this.buscando === false) {
          this.buscando = true;
          this.verificar = false;
          let type = "search";

          this.$vs.notify({ title: 'Buscando clientes...', text: 'Espere un momento', color: 'dark', position: 'bottom-center', icon: 'access_time' })
          axios.post(`/api/clients-control/${type}`, {
            search: this.search
          }).then((resolve) => {
            this.$vs.notify({ title: '¡Listo!', text: 'Datos cargados correctamente', color: 'success', position: 'bottom-center', icon: 'done' })
            this.data = resolve.data.data;
            this.active_data = resolve.data.data;
            this.active_data_identity = resolve.data.data;
            this.active_data_bank = resolve.data.data;
            this.active_data_stp = resolve.data.data;
            this.buscando = false;
          }).catch(error => {
            this.buscando = false;
            this.$vs.notify({ title: '¡ERROR!', text: 'Algo salió mal...', color: 'danger', position: 'bottom-center', icon: 'error' })
          });
        }
      }
    },
    changePersonalData() {
      this.$vs.notify({ title: 'Cambiando datos...', text: 'Espere un momento', color: 'dark', position: 'bottom-center', icon: 'access_time' })
      axios.post('/api/clients-control/edit', {
        ppid: this.elemento.ppid,
        first_name: this.elemento.first_name,
        second_name: this.elemento.second_name,
        last_name_1: this.elemento.last_name_1,
        last_name_2: this.elemento.last_name_2,
        birth_date: this.elemento.birth_date,
        curp: this.elemento.curp,
        gender: this.elemento.gender,
        citizenship: this.elemento.citizenship,
      }).then((resolve) => {
        this.$vs.notify({ title: '¡Listo!', text: 'Datos cambiados correctamente', color: 'success', position: 'bottom-center', icon: 'done' })
        this.reasons = '';
        this.titleIdentidad = this.elemento.name + " | V. Identidad";
        this.getCliensInVerification("identity");
        this.getCliensInVerification("bank");
        this.getCliensInVerification("stp");
        this.searchClient();
      }).catch(error => {
        this.$vs.notify({ title: '¡ERROR!', text: 'Algo salió mal...', color: 'danger', position: 'bottom-center', icon: 'error' })
      });
    },
    async getClientDocuments() {
      this.id_front = ''
      this.id_back = ''
      this.accountfile = ''
      if (this.elemento.iid != null) {
        var dids = [100, 101, 102];
        if (this.elemento.bpid != null) {
          dids = [103, 104, 109];
        }
      } else {
        var dids = [14, 15, 40];
        if (this.elemento.bpid != null) {
          dids = [21, 22, 94];
        }
      }


      this.id_front = await this.getFile(this.elemento.uid, dids[0]);
      this.id_back = await this.getFile(this.elemento.uid, dids[1]);
    },
    async getFile(user_id, document_id) {
      try {
        var url_data = `/storagev3/documents/files/${document_id}/user/${user_id}`
        let response = await axios.get(url_data);
        if (response.data.length > 0) {
          var file = response.data[0];
          return {
            url_file: `/storagev3/documents/view_document_file/${file.id}/user/${user_id}?access_token=${this.user.access_token}`,
            filename: file.storage_file
          }
        } else {
          return '';
        }

      } catch (e) {
        return '';
      }
    },
    verExpediente(renglon) {
      this.showModal('expediente', renglon);
      this.loading = true;
      this.pp = null;
      this.tipousuario = null;
      this.tipopersona = null;
      this.userid = null;
      this.email = null;
      this.transacciones = null;
      this.acceso = null;
      this.login = null;
      this.mfa = null;
      axios.post('/api/clients-control/curp-verification/pp/get', {
        'emailOrUID': renglon.email
      }).then((resolve) => {
        this.pp = resolve.data.pp;
        this.tipousuario = resolve.data.tipousuario;
        this.tipopersona = resolve.data.tipopersona;
        this.userid = resolve.data.user_id;
        this.email = resolve.data.email;
        this.transacciones = resolve.data.transacciones;
        this.acceso = resolve.data.acceso;
        this.login = resolve.data.login;
        this.mfa = resolve.data.mfa;
        this.loading = false;
      });
    },
    async verPanel(renglon) {
      this.showModal('panel', renglon);
      this.user_crs = [];
      await axios.post('/api/clients-control/compliance-panel/requirements', {
        'uid': renglon.uid,
        'user_type': renglon.iid !== null ? 'investor' : 'applicant'
      }).then((resolve) => {
        this.user_crs = resolve.data;
      });
    },
    verSTP(renglon, type) {
      this.type = type;
      this.showModal('stp', renglon);
      this.user_stp_ac = [];

      if (type === 'Inversionista') {
        axios.post('/api/clients-control/investor/stp/get', {
          'iid': renglon.iid,
        }).then((resolve) => {
          this.user_stp_ac = resolve.data.data;
        });
      } else if (type === 'Solicitante') {
        axios.post('/api/clients-control/applicant/stp/get', {
          'aid': renglon.cid,
        }).then((resolve) => {
          this.user_stp_ac = resolve.data.data;
          this.user_stp_pr = resolve.data.projects;
        });
      } else {
        axios.post('/api/clients-control/supplier/stp/get', {
          'sid': renglon.sid,
        }).then((resolve) => {
          this.user_stp_ac = resolve.data.data;
        });
      }

    },
    crearCuentaSTP(type) {
      this.$vs.notify({ title: 'Creando cuenta...', text: 'Espere un momento', color: 'dark', position: 'bottom-center', icon: 'access_time' })
      if (type === 'Inversionista') {
        this.liga = `v1/account/investorId/${this.elemento.iid}`
      } else if (type === 'Solicitante') {
        this.liga = `v1/account/applicantId/${this.elemento.cid}`
      } else {
        this.liga = `v1/account/supplierId/${this.elemento.sid}`
      }

      axios.post(`/api/stp/${this.liga}`).then((resolve) => {
        this.$vs.notify({ title: '¡Listo!', text: 'Cuenta creada correctamente', color: 'success', position: 'bottom-center', icon: 'done' })
        this.$vs.notify({ title: 'Cargando...', text: 'Espere un momento', color: 'dark', position: 'bottom-center', icon: 'access_time' })
        this.getCliensInVerification("identity");
        this.getCliensInVerification("bank");
        this.getCliensInVerification("stp");
        this.$vs.notify({ title: '¡Listo!', text: 'Datos cargados correctamente', color: 'success', position: 'bottom-center', icon: 'done' })
        this.hideModal('stp');
      }).catch(error => {
        this.$vs.notify({ title: '¡ERROR!', text: 'Algo salió mal...', color: 'danger', position: 'bottom-center', icon: 'error' })
      });
    },
    verEDC(id) {
      const index = this.showedEDC.indexOf(id);
      if (index > -1) {
        this.showedEDC.splice(index, 1)
      } else {
        this.showedEDC.push(id)
      }
    },
    verCuenta(id) {
      const index = this.showedCuentas.indexOf(id);
      if (index > -1) {
        this.showedCuentas.splice(index, 1)
      } else {
        this.showedCuentas.push(id)
      }
    },
    checkUrl(cuenta) {
      if (cuenta.document_file_id != null) {
        return `files/getDocumentFile/${cuenta.document_file_id}`;
      }
      return "";
    },
    viewUrl(cuenta) {
      if (cuenta.document_file_id != null) {
        return `view_document_file/${cuenta.document_file_id}/user/${this.elemento.uid}`;
      }
      return "";
    },
    downloadUrl(cuenta) {
      if (cuenta.document_file_id != null) {
        return `download_document_file/${cuenta.document_file_id}/user/${this.elemento.uid}`;
      }
      return "";
    },
    async getCollections() {
      try {
        let collectionsObjects = ['countriesList'];
        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
        let colls = res.data;
        let options = [];
        colls.countriesList.forEach(opt => {
          options.push({ value: opt.id, text: opt.name }); //conversion a sintaxis de vx-select 
        })
        this.collections.countries = options;
      } catch (e) {
        this.warn(e);
        this.failed = true;
      }
    },
    async handleSelected(id) {
      window.open(`backoffice/project/${id}`, '_blank');
    },
  },
  watch: {
    elemento: function () {
      if (this.elemento != null) {
        this.messages = []
        axios.post('/api/clients-control/notes/get', {
          iid: this.elemento.iid,
          cid: this.elemento.cid,
        }).then((resolve) => {
          this.messages = resolve.data.notes;
        });
      }
    },
    verificar: function () {
      if (this.verificar) {
        this.active_data = this.clientsInVerification;
        this.active_data_identity = this.identityVerificationData;
        this.active_data_bank = this.bankVerificationData;
        this.active_data_stp = this.stpAccountsVerificationData;
      } else {
        this.active_data = this.data;
        this.active_data_identity = this.data;
        this.active_data_bank = this.data;
        this.active_data_stp = this.data;
      }
    }
  },
  computed: {
    BankAccountStatus() {
      return BankAccountStatus
    },
    fullName() {
      if (this.elemento != null) {
        return this.elemento.first_name + ' ' + this.elemento.second_name + ' ' + this.elemento.last_name_1 + ' ' + this.elemento.last_name_2;
      }
    },
    ...mapState('auth', ['user']),
  },
}
</script>
<style scoped>
embed {
  height: 300px !important;
}
</style>